import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery } from 'react-query'
import { fetchTeamPlaybooks } from '@dc-shared-web/hooks/api/cl-cs/fetchTeamPlaybooks'
import { PlaybookListResponse } from '@dc-shared-web/hooks/api/cl-cs/types'

export const useGetTeamPlaybooks = ({
  crunchUuids,
  page = 1,
}: {
  crunchUuids: string
  page?: number
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<PlaybookListResponse, Error>(
    ['team-playbooks', crunchUuids, page],
    async () => {
      const playbooks = await fetchTeamPlaybooks(apiClient, {
        crunchUuids,
        page,
      })

      return playbooks
    },
    {
      enabled: !!crunchUuids && crunchUuids.length > 0,
      keepPreviousData: true,
    }
  )
}
